import React, { useState } from 'react';
import PropTypes from 'prop-types';

import { Box, IconButton, TextField } from '@mui/material';

import { AddOutlined, CheckOutlined, ClearOutlined } from '@mui/icons-material';

import { diagnosisDialogStyles } from './diagnosisStyles';
import { textFieldSx, actionWrapperSx,actionIconSx,iconButtonNoAnimationSx,clearIconSx,actionSvgSx,addIconSx } from '../Styles/InputStyles';

const DiagnosisSearch = ({ searchValue, onSearchChange, onAddDiagnosis }) => {
  const [showManualEntry, setShowManualEntry] = useState(false);

  const [code, setCode] = useState('');
  const [description, setDescription] = useState('');

  const isValid = Boolean(code.trim() && description.trim());

  const resetManualEntry = () => {
    setCode('');
    setDescription('');
    setShowManualEntry(false);
  };

  const handleAdd = () => {
    if (!isValid) return;

    onAddDiagnosis({
      id: `custom-${Date.now()}`,
      code: code.trim(),
      description: description.trim(),
      isCustom: true
    });

    resetManualEntry();
  };

  const handleKeyDown = event => {
    if (event.key === 'Enter' && isValid) {
      event.preventDefault();
      handleAdd();
    }

    if (event.key === 'Escape') {
      resetManualEntry();
    }
  };

  return (
    <>
      <Box sx={diagnosisDialogStyles.searchRow}>
        <TextField
          fullWidth
          value={searchValue}
          placeholder="Search user codes and descriptions"
          onChange={event => onSearchChange(event.target.value)}
          sx={textFieldSx}
        />

        <IconButton
          aria-label="Add diagnosis manually"
          onClick={() => setShowManualEntry(current => !current)}
          sx={diagnosisDialogStyles.addToggleButton}>
          <AddOutlined sx={{ fontSize: 24 }} />
        </IconButton>
      </Box>

      {showManualEntry && (
        <Box sx={diagnosisDialogStyles.manualRow} onKeyDown={handleKeyDown}>
          <TextField
            value={code}
            placeholder="Input Code"
            onChange={event => setCode(event.target.value)}
            sx={textFieldSx}
          />

          <TextField
            value={description}
            placeholder="Input Description"
            onChange={event => setDescription(event.target.value)}
            sx={{ ...textFieldSx, width: '100%' }}
          />
          <Box
            sx={{
              ...actionWrapperSx,
              justifyContent: 'flex-end',
              width: 'auto'
            }}>
            <IconButton
              aria-label="Save diagnosis"
              disabled={!isValid}
              onClick={handleAdd}
              sx={{
                ...actionIconSx,
                ...addIconSx,
                ...iconButtonNoAnimationSx
              }}>
              <CheckOutlined sx={actionSvgSx} />
            </IconButton>

            <IconButton
              aria-label="Cancel diagnosis entry"
              onClick={resetManualEntry}
              sx={{
                ...actionIconSx,
                ...clearIconSx,
                ...iconButtonNoAnimationSx
              }}>
              <ClearOutlined sx={actionSvgSx} />
            </IconButton>
          </Box>
        </Box>
      )}
    </>
  );
};

DiagnosisSearch.propTypes = {
  searchValue: PropTypes.string,
  onSearchChange: PropTypes.func,
  onAddDiagnosis: PropTypes.func
};

DiagnosisSearch.defaultProps = {
  searchValue: '',
  onSearchChange: () => {},
  onAddDiagnosis: () => {}
};

export default DiagnosisSearch;
